
export const word_info = 'Microsoft Word is a text document creation application included in the Microsoft 365 suite. It allows users to create, edit, format, and share text-based documents such as reports, letters, resumes, and more.'

export const word_md = `
# Microsoft Word  
*Last updated on July 14, 2025*

## Overview

Microsoft Word is a text document creation application included in the Microsoft 365 suite. 
It allows you to create, edit, format, and share text-based documents such as reports, letters, resumes, and more.

## Benefits
- **Easy to Use**: Intuitive interface with powerful formatting tools.
- **Collaboration**: Real-time collaboration with co-authoring support.
- **Integration**: Seamless integration with other Microsoft 365 apps like Outlook and OneDrive.
- **Version History**: Cloud autosave and version history for documents.
- **Accessibility**: Accessibility features for inclusive document creation.

## Requirements
- A user account with us
- A valid Microsoft 365 subscription
- An up to date version of Windows

## Getting Started
- Word gets installed as part of the [Microsoft 365](https://it.bockwaterheaters.com/#/services/m365) suite.

For online access, go to [https://m365.cloud.microsoft/apps/](https://m365.cloud.microsoft/apps/), sign in, and then click on the Word icon.

## Support
- Contact our [IT Help Desk](https://it.bockwaterheaters.com/#/help)


`